import {Injectable, Inject} from '@angular/core';
import { Http, Response, Headers, RequestOptions, RequestMethod } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import {TokenHttp} from './token-http';
import {KvStringItem} from '../models/kv-string-item';
import {ChangePasswordModel} from '../models/change-password-model';
import {CurrentUser} from '../models/current-user';

@Injectable()
export class AuthenticationService {

  constructor(private http: Http,
              private options: RequestOptions,
              private dandpHttp: TokenHttp,
              @Inject('ApplicationConfig') private config: any) { }

  login(username: string, password: string, totp: string) {
    const headers = new Headers();
    const body = 'grant_type=password&username=' + username + '&password=' +
      password + '&client_id=' + this.config.clientId;
      headers.append('Content-Type', 'application/x-www-form-urlencoded');
      headers.append('X-OTP', totp);
    this.options.body = body;
    this.options.headers = headers;
    this.options.withCredentials = false;
    this.options.method = RequestMethod.Post;
    return this.http.request(this.config.apiEndpoint + '/authtoken', this.options)
      .map((res: Response) => res.json())
      .map((res: any) => {
        sessionStorage.setItem('access_token', res.access_token);
        sessionStorage.setItem('refresh_token', res.refresh_token);
        return new CurrentUser(res.firstname,
           res.lastname,
           res.role,
           res.userName,
           res.changePw === 'True',
           '',
           res.acceptedAgreement === 'True');
      })
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  aliasUser(user: string): Observable<CurrentUser> {
    sessionStorage.setItem('aliasId', user);
    return this.dandpHttp.refreshTheToken(sessionStorage.getItem('access_token'))
      .map((res: Response) => res.json())
      .map((res: any) => {
        sessionStorage.setItem('access_token', res.access_token);
        sessionStorage.setItem('refresh_token', res.refresh_token);
        return new CurrentUser(res.firstname,
          res.lastname,
          res.role,
          res.userName,
          res.changePw === 'True',
          '',
          res.acceptedAgreement === 'True');
      })
      .catch((error: any) => Observable.throw(error || 'Server error'));

  }

  logout() {
    return this.dandpHttp.get(this.config.apiEndpoint + '/api/account/logout')
      .map((res: Response) => res.json())
      .map((res: any) => {
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('refresh_token');
        sessionStorage.removeItem('aliasId');
      })
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  resetPassword(usr: string): Observable<boolean> {
    const headers = new Headers();
    const body = new KvStringItem(usr);
    headers.append('Content-Type', 'application/json');
    this.options.body = body;
    this.options.headers = headers;
    this.options.withCredentials = false;
    this.options.method = RequestMethod.Post;
    return this.http.request(this.config.apiEndpoint + '/api/account/resetpassword', this.options)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

  changePassword(pwModel: ChangePasswordModel): Observable<boolean> {
    return this.dandpHttp.post(this.config.apiEndpoint + '/api/account/changepassword', pwModel)
      .map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error || 'Server error'));
  }

}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/services/authentication.ts